import React, { useContext, useEffect, useState } from 'react';

import { useHistory, Link } from 'react-router-dom';

import MUIDataTable from "mui-datatables";
import { Box, Tooltip, Typography } from '@mui/material';
import { Chip } from '@mui/material';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faEdit, faMobile, faMobileAlt, faPlay, faStop, faThList, faTicket, faTrash } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@mui/material';


//export default class TablaProductos extends Component
export default function CashlessEconomyParticipantsDataTable({participants,onRefresh})
{
    //const [participants,setPos] = useState([]);
    //const [isLoading,setIsLoading] = useState(false);

    //id uuid terminal merchant name brand type status 

    const columns = [
        {
            name : 'id',
            label : 'ID',
            options : 
            {
                filter:false,
                searchable:true
            }
        },
        {
            name : 'entity.name',
            label : 'Merchant',
            options:{
                customBodyRenderLite : (dataIndex) => {
                    //let id = subCategorias[dataIndex].idSubCategoria;
                    return(
                        participants[dataIndex].entity.name
                    );
                },
                filter:true,
                searchable:true
            }
        },
        {
            name : 'entity.type',
            label : 'Merchant type',
            options:{
                customBodyRenderLite : (dataIndex) => {
                    //let id = subCategorias[dataIndex].idSubCategoria;
                    return(
                        participants[dataIndex].entity.type
                    );
                },
                filter:true,
                searchable:true
            }
        },
        {
            name : 'status',
            label : 'Estatus',
            options : 
            {
                customBodyRender : (value, tableMeta, updateValue) => (
                    value === 'active'
                    ? <Chip label='Activo' color='success'/>
                    : <Chip label='Inactivo' color='error' />
                )            
            }
        },
        {
            name : '',
            label : 'Acciones',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    //let id = subCategorias[dataIndex].idSubCategoria;
                    return(
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
                            <Link 
                                //onClick = { () => handleChangeStatus(participants[dataIndex].id)  }  
                            >
                                <IconButton>
                                {
                                    participants[dataIndex].status === 'active'
                                    ? 
                                    <Tooltip title='Inactivar' placement="top">
                                        <FontAwesomeIcon icon={faStop}/>
                                    </Tooltip>
                                    :
                                    <Tooltip title='Activar' placement="top">
                                        <FontAwesomeIcon icon={faPlay}/>
                                    </Tooltip>
                                }
                                </IconButton>
                            </Link>

                            
                            <Link 
                                to={'/participants/update/'+participants[dataIndex].id} 
                                //onClick={ ()=> localStorage.setItem('evento',JSON.stringify(participants[dataIndex])) }
                                replace
                            >
                                <Tooltip title='Editar' placement='top'>
                                    <IconButton>
                                        <FontAwesomeIcon icon={faEdit}/>
                                    </IconButton>
                                </Tooltip>
                            </Link>

                            <Link 
                                to={'/cashless/participants/details/'+participants[dataIndex].uuid} 
                                //onClick={ ()=> localStorage.setItem('evento',JSON.stringify(participants[dataIndex])) }
                                replace
                            >
                                <Tooltip title='Crear POS' placement='top'>
                                    <IconButton>
                                        <FontAwesomeIcon icon={faMobileAlt}/>
                                    </IconButton>
                                </Tooltip>
                            </Link>
                        </div>
                    );
                },

                filter:false,
                print:false
            }
        }
    ];


    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
      };


    return(
        <>
            <MUIDataTable
            
                title={"Listado de Participantes"}
                data={participants}
                columns={columns}
                options={options}
            />
        </>
    )
}